import {request, serviceUrl} from "@/utils/request";

//根据设备联动id和动作ID获取联动动作日志数据
export function getListByLinkageIdAndActionId(linkageId, actionId) {
  return request({
    url: serviceUrl.deviceService + '/device/linkage-action/logs/getListByLinkageIdAndActionId',
    params: {
      linkageId,
      actionId
    }
  })
}

// 告警配置列表分页
export function getPageByLinkageIdAndActionId(pageCurrent = null, pageSize = null, linkageId = null, actionId = null) {
  return request({
    method:'post',
    url: serviceUrl.deviceService + '/device/linkage-action/logs/getPageByLinkageIdAndActionId',
    data: {
      pageCurrent,
      pageSize,
      linkageId,
      actionId
    }
  })
}
